import { ApolloError } from '@parkchirp/api-client';

export function getErrorMessage(err: ApolloError, errorCodes?: string[]) {
	if (!errorCodes || !errorCodes.length) return err.message;

	if (errorCodes.includes(err.graphQLErrors[0]?.extensions.code as string)) {
		return err.message;
	}

	return null;
}
